import AbsaBankLogo from '../../assets/banks/AbsaBankLogo.svg';
import CapitecBankLogo from '../../assets/banks/CapitecBankLogo.svg';
import FNBBankLogo from '../../assets/banks/FNBLogo.svg';
import GenericBankIcon from '../../assets/banks/GenericBankLogo.svg';
import InvestecBankLogo from '../../assets/banks/InvestecBankLogo.svg';
import NedbankBankLogo from '../../assets/banks/NedbankLogo.svg';
import AfricanBankLogo from '../../assets/banks/AfricanBankLogo.svg';
import DiscoveryBankLogo from '../../assets/banks/DiscoveryBankLogo.svg';
import GrindrodBankLogo from '../../assets/banks/GrindrodBankLogo.svg';
import StandardBankLogo from '../../assets/banks/StandardBankLogo.svg';
import BidvestBankLogo from '../../assets/banks/BidvestBankLogo.svg';

export type BankIcons =
  | 'Absa'
  | 'Capitec'
  | 'FNB'
  | 'Investec'
  | 'Nedbank'
  | 'AfricanBank'
  | 'DiscoveryBank'
  | 'Grindrod'
  | 'Bidvest'
  | 'StandardBank';

export const getBankIcon = (bank: BankIcons | undefined) => {
  switch (bank) {
    case 'Absa':
      return AbsaBankLogo;
    case 'Bidvest':
      return BidvestBankLogo;
    case 'Capitec':
      return CapitecBankLogo;
    case 'FNB':
      return FNBBankLogo;
    case 'Investec':
      return InvestecBankLogo;
    case 'Nedbank':
      return NedbankBankLogo;
    case 'AfricanBank':
      return AfricanBankLogo;
    case 'DiscoveryBank':
      return DiscoveryBankLogo;
    case 'Grindrod':
      return GrindrodBankLogo;
    case 'StandardBank':
      return StandardBankLogo;
    default:
      return GenericBankIcon;
  }
};
